import { render, staticRenderFns } from "./LoanForm.vue?vue&type=template&id=68b4f941"
import script from "./LoanForm.vue?vue&type=script&lang=js"
export * from "./LoanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports